/* eslint-disable */

/** unique or primary key constraints on table "argo.material_attribute" */
export enum ArgoMaterialAttributeConstraint {
  /** unique or primary key constraint on columns "material_attribute_id" */
  MaterialAttributePkey = 'material_attribute_pkey',
  /** unique or primary key constraint on columns "context_id", "attribute_id", "material_id" */
  MaterialAttributeUnique = 'material_attribute_unique'
}

/** select columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeSelectColumnArgoMaterialAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeSelectColumnArgoMaterialAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.material_attribute" */
export enum ArgoMaterialAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

